module.exports = __webpack_public_path__ + "img/like_btn.6d286147.png";